export default "__VITE_PUBLIC_ASSET__ccc621c3__"